import { gql } from "@apollo/client";

export const GET_PERSON_RELATIONSHIPS = gql`
  query GET_PERSON_RELATIONSHIPS($personId: ID!, $originatorId: ID!) {
    getPerson(personId: $personId, originatorId: $originatorId) {
      id
      relationships {
        id
        relationshipType {
          id
          name
        }
        person {
          aliases {
            id
            target {
              id
              validPersonAlerts {
                alertType {
                  name
                  alertLevel
                }
              }
            }
          }
          id
          personalAttribute {
            lastName
            firstName
            middleName
            suffix
            organization
            dob
            phone
            homeAddress {
              id
              city
              lat
              lng
              name
              state
              streetName
              streetNumber
              unit
              zip
              validAddressAlerts {
                alertType {
                  id
                  name
                  alertLevel
                  oriId
                  position
                }
                expireAt
                id
                notes
                createdAt
                officer {
                  deptAttribute {
                    id
                    badge
                    ori {
                      id
                      abbreviation
                    }
                  }
                  personalAttribute {
                    id
                    firstName
                    lastName
                  }
                }
              }
            }
          }
          validPersonAlerts {
            alertType {
              id
              name
              alertLevel
              oriId
              position
            }
            expireAt
            createdAt
            officer {
              deptAttribute {
                id
                badge
                ori {
                  id
                  abbreviation
                }
              }
              personalAttribute {
                id
                firstName
                lastName
              }
            }
            id
            notes
            officerId
            person {
              id
            }
          }
        }
      }
    }
  }
`;
